import { TenantEntity } from '../TenantEntity'
import { externalAutoAllocate } from '@/api/seaExport/warehouseIn'
import { loadWarehouseInRelated } from '@/api/warehouseIn/warehouseIn'
import { getWarehouseInDetail } from '@/api/booking/warehouseInDetail'
export class WarehouseIn extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'WarehouseIn'
  }
  get warehouseId() {
    return this._data.warehouseId
  }
  set warehouseId(warehouseId) {
    this._data.warehouseId = warehouseId
  }
  get warehouse() {
    return this._data.warehouse
  }
  set warehouse(warehouse) {
    this._data.warehouse = warehouse
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId
  }
  get warehouseNo() {
    return this._data.warehouseNo
  }
  set warehouseNo(warehouseNo) {
    this._data.warehouseNo = warehouseNo
  }
  get receiptNo() {
    return this._data.receiptNo
  }
  set receiptNo(receiptNo) {
    this._data.receiptNo = receiptNo
  }
  get warehouseOp() {
    return this._data.warehouseOp
  }
  set warehouseOp(warehouseOp) {
    this._data.warehouseOp = warehouseOp
  }
  get location() {
    return this._data.location
  }
  set location(location) {
    this._data.location = location
  }
  get palletSum() {
    return this._data.palletSum
  }
  set palletSum(palletSum) {
    this._data.palletSum = palletSum
  }
  get quantitySum() {
    return this._data.quantitySum
  }
  set quantitySum(quantitySum) {
    this._data.quantitySum = quantitySum
  }
  get weightSum() {
    return this._data.weightSum
  }
  set weightSum(weightSum) {
    this._data.weightSum = weightSum
  }
  get cubageSum() {
    return this._data.cubageSum
  }
  set cubageSum(cubageSum) {
    this._data.cubageSum = cubageSum
  }
  get deliveryCmp() {
    return this._data.deliveryCmp
  }
  set deliveryCmp(deliveryCmp) {
    this._data.deliveryCmp = deliveryCmp
  }
  get truckNo() {
    return this._data.truckNo
  }
  set truckNo(truckNo) {
    this._data.truckNo = truckNo
  }
  get driver() {
    return this._data.driver
  }
  set driver(driver) {
    this._data.driver = driver
  }
  get driverTel() {
    return this._data.driverTel
  }
  set driverTel(driverTel) {
    this._data.driverTel = driverTel
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get broken() {
    return this._data.broken
  }
  set broken(broken) {
    this._data.broken = broken
  }
  get brokenQuantity() {
    return this._data.brokenQuantity
  }
  set brokenQuantity(brokenQuantity) {
    this._data.brokenQuantity = brokenQuantity
  }
  get brokenDes() {
    return this._data.brokenDes
  }
  set brokenDes(brokenDes) {
    this._data.brokenDes = brokenDes
  }
  get comments() {
    return this._data.comments
  }
  set comments(comments) {
    this._data.comments = comments
  }
  get receiveDc() {
    return this._data.receiveDc
  }
  set receiveDc(receiveDc) {
    this._data.receiveDc = receiveDc
  }
  get warehouseInDate() { // 实际入库时间
    return this._data.warehouseInDate
  }
  set warehouseInDate(warehouseInDate) {
    this._data.warehouseInDate = warehouseInDate
  }
  get warehouseOutDate() { // 实际出库时间
    return this._data.warehouseOutDate
  }
  set warehouseOutDate(warehouseOutDate) {
    this._data.warehouseOutDate = warehouseOutDate
  }
  get estimatedWarehousingTime() { // 预计入库时间
    return this._data.estimatedWarehousingTime
  }
  set estimatedWarehousingTime(estimatedWarehousingTime) {
    this._data.estimatedWarehousingTime = estimatedWarehousingTime
  }
  get estimatedDeliveryTime() { // 预计出库时间
    return this._data.estimatedDeliveryTime
  }
  set estimatedDeliveryTime(estimatedDeliveryTime) {
    this._data.estimatedDeliveryTime = estimatedDeliveryTime
  }
  get outType() {
    return this._data.outType
  }
  set outType(outType) {
    this._data.outType = outType
  }
  get label() {
    return this._data.label
  }
  set label(label) {
    this._data.label = label
  }
  get warehouseNoFormat() {
    return this._data.warehouseNoFormat
  }
  set warehouseNoFormat(warehouseNoFormat) {
    this._data.warehouseNoFormat = warehouseNoFormat
  }
  get sealCargo() {
    return this._data.sealCargo
  }
  set sealCargo(sealCargo) {
    this._data.sealCargo = sealCargo
  }
  get sealWeight() {
    return this._data.sealWeight
  }
  set sealWeight(sealWeight) {
    this._data.sealWeight = sealWeight
  }
  get lob() {
    return this._data.lob
  }
  set lob(lob) {
    this._data.lob = lob
  }
  get referenceNo() {
    return this._data.referenceNo
  }
  set referenceNo(referenceNo) {
    this._data.referenceNo = referenceNo
  }
  get instoreFrom() {
    return this._data.instoreFrom
  }
  set instoreFrom(instoreFrom) {
    this._data.instoreFrom = instoreFrom
  }
  get outstoreTo() {
    return this._data.outstoreTo
  }
  set outstoreTo(outstoreTo) {
    this._data.outstoreTo = outstoreTo
  }
  get marks() {
    return this._data.marks
  }
  set marks(marks) {
    this._data.marks = marks
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get warehouseUuid() {
    return this._data.warehouseUuid
  }
  set warehouseUuid(warehouseUuid) {
    this._data.warehouseUuid = warehouseUuid
  }
  get quantityContract() {
    return this._data.quantityContract
  }
  set quantityContract(quantityContract) {
    this._data.quantityContract = quantityContract
  }
  get weightContract() {
    return this._data.weightContract
  }
  set weightContract(weightContract) {
    this._data.weightContract = weightContract
  }
  get cubageContract() {
    return this._data.cubageContract
  }
  set cubageContract(cubageContract) {
    this._data.cubageContract = cubageContract
  }
  get volumetricWeightContract() {
    return this._data.volumetricWeightContract
  }
  set volumetricWeightContract(volumetricWeightContract) {
    this._data.volumetricWeightContract = volumetricWeightContract
  }
  get chargeWeightContract() {
    return this._data.chargeWeightContract
  }
  set chargeWeightContract(chargeWeightContract) {
    this._data.chargeWeightContract = chargeWeightContract
  }
  get warehouseInDateFrom() {
    return this._data.warehouseInDateFrom
  }
  set warehouseInDateFrom(warehouseInDateFrom) {
    this._data.warehouseInDateFrom = warehouseInDateFrom
  }
  get warehouseInDateTo() {
    return this._data.warehouseInDateTo
  }
  set warehouseInDateTo(warehouseInDateTo) {
    this._data.warehouseInDateTo = warehouseInDateTo
  }
  get etd() {
    return this._data.etd
  }
  set etd(etd) {
    this._data.etd = etd
  }
  get vehicleType() {
    return this._data.vehicleType
  }
  set vehicleType(vehicleType) {
    this._data.vehicleType = vehicleType
  }
  get state() {
    return this._data.state
  }
  set state(state) {
    this._data.state = state
  }
  get supplierId() {
    return this._data.supplierId
  }
  set supplierId(supplierId) {
    this._data.supplierId = supplierId
  }
  get warehouseInRequirement() {
    return this._data.warehouseInRequirement
  }
  set warehouseInRequirement(warehouseInRequirement) {
    this._data.warehouseInRequirement = warehouseInRequirement
  }
  get warehouseAddress() {
    return this._data.warehouseAddress
  }
  set warehouseAddress(warehouseAddress) {
    this._data.warehouseAddress = warehouseAddress
  }
  get warehouseContact() {
    return this._data.warehouseContact
  }
  set warehouseContact(warehouseContact) {
    this._data.warehouseContact = warehouseContact
  }
  get warehouseContactTel() {
    return this._data.warehouseContactTel
  }
  set warehouseContactTel(warehouseContactTel) {
    this._data.warehouseContactTel = warehouseContactTel
  }
  get notifyCmpId() {
    return this._data.notifyCmpId
  }
  set notifyCmpId(notifyCmpId) {
    this._data.notifyCmpId = notifyCmpId || 0
  }
  // ===================FBA新增字段======================
  get fba() {
    return this._data.fba
  }
  set fba(fba) {
    this._data.fba = fba || false
  }
  get weighTime() {
    return this._data.weighTime
  }
  set weighTime(weighTime) {
    this._data.weighTime = weighTime
  }
  get checklistTime() {
    return this._data.checklistTime
  }
  set checklistTime(checklistTime) {
    this._data.checklistTime = checklistTime
  }
  get returnGoodsTime() {
    return this._data.returnGoodsTime
  }
  set returnGoodsTime(returnGoodsTime) {
    this._data.returnGoodsTime = returnGoodsTime
  }
  get returnReason() {
    return this._data.returnReason
  }
  set returnReason(returnReason) {
    this._data.returnReason = returnReason
  }
  get electric() {
    return this._data.electric
  }
  set electric(electric) {
    this._data.electric = electric || false
  }
  get magnetic() {
    return this._data.magnetic
  }
  set magnetic(magnetic) {
    this._data.magnetic = magnetic || false
  }
  get powdery() {
    return this._data.powdery
  }
  set powdery(powdery) {
    this._data.powdery = powdery || false
  }
  get liquid() {
    return this._data.liquid
  }
  set liquid(liquid) {
    this._data.liquid = liquid || false
  }
  get checklistStatus() {
    return this._data.checklistStatus
  }
  set checklistStatus(checklistStatus) {
    this._data.checklistStatus = checklistStatus
  }
  get faceOrderPrintTime() {
    return this._data.faceOrderPrintTime
  }
  set faceOrderPrintTime(faceOrderPrintTime) {
    this._data.faceOrderPrintTime = faceOrderPrintTime
  }
  get courierNumber() {
    return this._data.courierNumber
  }
  set courierNumber(courierNumber) {
    this._data.courierNumber = courierNumber
  }
  get packingTime() {
    return this._data.packingTime
  }
  set packingTime(packingTime) {
    this._data.packingTime = packingTime
  }
  get refContainerNo() {
    return this._data.refContainerNo
  }
  set refContainerNo(refContainerNo) {
    this._data.refContainerNo = refContainerNo
  }
  get oversea() {
    return this._data.oversea
  }
  set oversea(oversea) {
    this._data.oversea = oversea
  }
  get pallet() {
    return this._data.pallet
  }
  set pallet(pallet) {
    this._data.pallet = pallet
  }
  get labelingTime() {
    return this._data.labelingTime
  }
  set labelingTime(labelingTime) {
    this._data.labelingTime = labelingTime
  }
  get outWarehouseStatus() {
    return this._data.outWarehouseStatus
  }
  set outWarehouseStatus(outWarehouseStatus) {
    this._data.outWarehouseStatus = outWarehouseStatus || 0
  }
  get overseaWarehouseCode() {
    return this._data.overseaWarehouseCode
  }
  set overseaWarehouseCode(overseaWarehouseCode) {
    this._data.overseaWarehouseCode = overseaWarehouseCode || ''
  }
  get relateWarehouseInUuid() { // 国外仓对应的国内仓uuid
    return this._data.relateWarehouseInUuid
  }
  set relateWarehouseInUuid(relateWarehouseInUuid) {
    this._data.relateWarehouseInUuid = relateWarehouseInUuid
  }
  // ===========FBA JOB 相关===============
  get customerId() {
    return this._data.customerId
  }
  set customerId(customerId) {
    this._data.customerId = customerId || ''
  }
  get serviceChannel() {
    return this._data.serviceChannel
  }
  set serviceChannel(serviceChannel) {
    this._data.serviceChannel = serviceChannel || ''
  }
  get warehouseCode() {
    return this._data.warehouseCode
  }
  set warehouseCode(warehouseCode) {
    this._data.warehouseCode = warehouseCode || ''
  }
  get remoteWarehouse() {
    return this._data.remoteWarehouse
  }
  set remoteWarehouse(remoteWarehouse) {
    this._data.remoteWarehouse = remoteWarehouse || false
  }
  get country() {
    return this._data.country
  }
  set country(country) {
    this._data.country = country || ''
  }
  get zipCode() {
    return this._data.zipCode
  }
  set zipCode(zipCode) {
    this._data.zipCode = zipCode || ''
  }
  get shippingType() {
    return this._data.shippingType
  }
  set shippingType(shippingType) {
    this._data.shippingType = shippingType || ''
  }
  get destinationDistribution() {
    return this._data.destinationDistribution
  }
  set destinationDistribution(destinationDistribution) {
    this._data.destinationDistribution = destinationDistribution || ''
  }
  get expressCompany() {
    return this._data.expressCompany
  }
  set expressCompany(expressCompany) {
    this._data.expressCompany = expressCompany || ''
  }
  get chargingMethod() {
    return this._data.chargingMethod
  }
  set chargingMethod(chargingMethod) {
    this._data.chargingMethod = chargingMethod || ''
  }
  get bubbleCountingRatio() {
    return this._data.bubbleCountingRatio
  }
  set bubbleCountingRatio(bubbleCountingRatio) {
    this._data.bubbleCountingRatio = bubbleCountingRatio || 0.0
  }
  get bubbleSplittingRatio() {
    return this._data.bubbleSplittingRatio
  }
  set bubbleSplittingRatio(bubbleSplittingRatio) {
    this._data.bubbleSplittingRatio = bubbleSplittingRatio || 0.0
  }
  get poNumber() {
    return this._data.poNumber
  }
  set poNumber(poNumber) {
    this._data.poNumber = poNumber || ''
  }
  get chargeWeightAct() {
    return this._data.chargeWeightAct
  }
  set chargeWeightAct(chargeWeightAct) {
    this._data.chargeWeightAct = chargeWeightAct || 0.0
  }

  // ===========FBA关联表数据===============
  get businessDocumentVOList() {
    return this._data.businessDocumentVOList
  }
  set businessDocumentVOList(businessDocumentVOList) {
    this._data.businessDocumentVOList = businessDocumentVOList || []
  }
  get operationRequirementVOList() {
    return this._data.operationRequirementVOList
  }
  set operationRequirementVOList(operationRequirementVOList) {
    this._data.operationRequirementVOList = operationRequirementVOList || []
  }
  get warehouseInDetailList() {
    return this._data.warehouseInDetailList
  }
  set warehouseInDetailList(warehouseInDetailList) {
    this._data.warehouseInDetailList = warehouseInDetailList || []
  }
  get fbaJobGoods() {
    return this._data.fbaJobGoods
  }
  set fbaJobGoods(fbaJobGoods) {
    this._data.fbaJobGoods = fbaJobGoods || []
  }
  get fbaPallets() {
    return this._data.fbaPallets
  }
  set fbaPallets(fbaPallets) {
    this._data.fbaPallets = fbaPallets || []
  }
  get fbaOutWarehouses() {
    return this._data.fbaOutWarehouses
  }
  set fbaOutWarehouses(fbaOutWarehouses) {
    this._data.fbaOutWarehouses = fbaOutWarehouses || []
  }
  // 关联业务信息
  get jobInfo() {
    return this._data.jobInfo
  }
  set jobInfo(jobInfo) {
    this._data.jobInfo = jobInfo
  }
  get airJobInfo() {
    return this._data.airJobInfo
  }
  set airJobInfo(airJobInfo) {
    this._data.airJobInfo = airJobInfo
  }
  get seaJobInfo() {
    return this._data.seaJobInfo
  }
  set seaJobInfo(seaJobInfo) {
    this._data.seaJobInfo = seaJobInfo
  }

  // 仓储入库明细
  get warehouseInDetail() {
    return this._data.warehouseInDetail
  }
  set warehouseInDetail(warehouseInDetail) {
    this._data.warehouseInDetail = warehouseInDetail
  }

  // 业务文档
  get business_Document() {
    return this._data.business_Document
  }
  set business_Document(business_Document) {
    this._data.business_Document = business_Document
  }

  get temperatureRequirement() {
    return this._data.temperatureRequirement
  }
  set temperatureRequirement(temperatureRequirement) {
    this._data.temperatureRequirement = temperatureRequirement
  }

  // 仓储入库明细
  async getWarehouseInDetail() {
    const data = this._data
    if (typeof data.warehouseInDetail !== 'object') {
      if (data.uuid) {
        data.warehouseInDetail = await getWarehouseInDetail({ warehouseInUuid: data.uuid }).then(res => res.data)
      } else {
        data.warehouseInDetail = []
      }
    }
    return data.warehouseInDetail
  }
  // 自动配货(外部接口)
  static async externalAutoAllocate(jobUuid, warehouseNo) {
    await externalAutoAllocate({ jobUuid, warehouseNo })
  }

  // 加载仓库的关联实体信息
  async loadWarehouseInRelated(params) {
    params.warehouseInUuid = params.warehouseInUuid || this._data.uuid
    if (!params.warehouseInUuid) return
    // 是否需要载入
    let needLoad = false
    // 将已经加载过的属性的标识置为false
    for (const key in params) {
      if (key === 'warehouseInUuid') {
        continue
      }
      if (key !== 'warehouseIn' && params[key] && typeof this._data[key] === 'object' && key !== 'fbaJobGoods' && key !== 'warehouseInDetail') {
        params[key] = false
      }
      if (params[key]) {
        needLoad = true
      }
    }
    if (!needLoad) {
      return
    }
    await loadWarehouseInRelated(params).then(res => {
      const items = res.data
      if (items.warehouseIn) {
        for (const key in items.warehouseIn) {
          if (typeof this._data[key] === 'object') {
            continue
          }
          this._data[key] = items.warehouseIn[key]
        }
      }
      for (const key in items) {
        if (key === 'warehouseIn') {
          continue
        }
        this._data[key] = items[key] || null
      }
    })
  }
}
